import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from '#src/pages/PrizePoolContenderPage/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const PrizePoolContenderPageComponent = () => {
  const { leaderboard, contender } = useTypedParams<PageParams>();

  return (
    <PrizePoolContenderPage leaderboard={leaderboard} contender={contender} />
  );
};

export default PrizePoolContenderPageComponent;
